import { MPAPISlice } from '@app/services';
import { AppSlice } from '@app/store';
import { AuthSlice } from '@pages/Authentication/store';
import { releasesApiSlice } from '@pages/Cli/store/DistService';
import { MainDashboardSlice } from '@pages/MainDashBoard/store';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

export const store = configureStore({
    reducer: {
        [MPAPISlice.reducerPath]: MPAPISlice.reducer,
        [releasesApiSlice.reducerPath]: releasesApiSlice.reducer,
        app: AppSlice.reducer,
        auth: AuthSlice.reducer,
        mainDashboard: MainDashboardSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(MPAPISlice.middleware, releasesApiSlice.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;

setupListeners(store.dispatch);
